module.exports = __webpack_public_path__ + "img/mentoria.23ddc228.jpg";